module.exports = __webpack_public_path__ + "img/accessory_pants_02.5f2821c8.svg";